export enum AppPrefixes {
    Article = 'Article',
    Diafilm = 'Diafilm',
    Headline = 'Headline'
}
export const PAGE_TYPES = {
    index: 'index',
    article: 'article',
    diafilm: 'diafilm',
    kindDetail: 'kind_detail',
    kindRating: 'kind_rating',
    kindAlphabet: 'kind_alphabet',
    kindCompilation: 'kind_compilation',
    error: 'error',
    rubric: 'rubric',
    consulationMain: 'consultation_main',
    consultantListing: 'consultant_listing',
    consultationRubric: 'consultation_rubric',
    consultationConsultant: 'consultation_consultant',
    consultantQuestion: 'consultant_question',
    consultantAsk: 'consultation_ask',
    search: 'search',
    tag: 'tag',
    authorDetail: 'author',
    names: 'names',
    user: 'user_page',
    author_listing: 'author_listing',
    market: 'market',
    marketCategory: 'market_category',
    marketProduct: 'market_product',
    marketSearch: 'market_search',
    marketQuiz: 'market_quiz',
    quiz: 'quiz',
    userContent: 'user_contest',
    collections: 'collections',
    addPet: 'add_pet',
} as const;
export const SIDEBAR_OFFSET = {
    STICKY_GAP_BASE: 20,
    STICKY_GAP_WITH_FIXED_HEADER: 68,
} as const;
